import React from 'react'
import "./BulletPoints.css"

const bulletData=[
    {
        heading: "Construction & Contracting",
        points: [
          "Construction Management",
          "Commercial Construction",
          "Specialized Construction",
          "Highway Construction & Drainage",
          "Residential Homebuilders",
          "Land Development & Site Preparation",
          "Residential Framing Contractors",
          "Commercial & Industrial Design-Build",
          "HVAC Installation, Services, Parts, & Distribution",
          "Fire Protection Installation & Service",
          "Electrical Commercial Contractors",
          "Residential Pool Contractors",
          "Stormwater Drainage Contractors"
        ]
      },
      {
        heading: "Manufacturing",
        points: [
          "Paint Manufacturing",
          "Chemical Companies",
          "Aerospace & Defense",
          "Specialized Packaging",
          "Industrial Pulp & Paper Machinery",
          "Flexible Packaging",
          "Precision Metals Fabrication",
          "Industrial Pump Manufacturing",
          "Industrial Parts, Wholesale & Retail",
          "Ready-Mix Concrete",
          "Corrugated Containers",
          "Electric Utilities Products",
          "Apparel & Textiles",
          "Forestry & Construction Materials",
          "Food Processing Equipment",
          "Industrial Casters & Wheels",
          // "Hyperbaric Oxygen Chambers",
          // "Food & Kindred Products",
          // "Furniture & Fixtures",
          // "Electronics & Other Electrical Equipment",
          // "Building Materials, Manufacturing & Retail",
          // "Valve Machining & Repairing",
          // "Contract Manufacturing & Design",
          // "Precision Bearings",
          // "Wood Display Products",
          // "Timing & Industrial Control Products",
          // "Precision Parts & Components"
        ]
      },
      {
        heading: "Professional Services",
        points: [
          "Architectural & Engineering",
          "Specialized Engineering",
          "Executive Search",
          "Business Consulting",
          "Healthcare Reimbursements",
          "Professional Staffing",
          "Market Research",
          "Advertising & Marketing",
          "Conflict Resolution & Mediation",
          "Public Opinion Polling",
          "Clinical Research Organizations"
        ]
      },
        {
        heading: "Information Technology",
        points: [
          "Software as a Service Firms (SaaS)",
          "Coding Bootcamps",
          "IT Management & Software Programming",
          "Computer Systems Integration & Design",
          "ERP Implementation & Consulting",
          "Homeland/Public Safety Technology",
          "Technology Start-ups",
          "Asset Tracking & Monitoring",
          "Industrial Automation & Systems Integration",
          "Commercial Electronic Security"
        ]
      },
      {
        heading: "Wholesale & Distribution",
        points: [
          "Industrial Pumps",
          "Wholesale Foods",
          "Beverage Distributors",
          "Transport Refrigeration Products",
          "Traffic Control Devices & Equipment",
          "Apparel & Textiles",
          "Irrigation Equipment",
          "Fiber Optics Equipment & Supplies",
          "Compressed Air Equipment & Maintenance",
          "Medical Supplies",
          "Lift Trucks & Materials Handling Equipment",
          "Public Safety Equipment & Supplies",
          "Oil & Gas Extraction",
          "Electrical Supplies"
        ]
      },
      {
        heading: "Finance, Insurance, and Real Estate",
        points: [
          "Banks & Financial Institutions",
          "Investment Managers",
          "Consumer Loan Brokers",
          "Hedge Funds",
          "Investment Holding Companies",
          "Real Estate Companies",
          "Real Estate Management",
          "Real Estate Development",
          "Holding & Other Investment Offices",
          "Residential & Commercial Mortgage Lenders",
          "Insurance Agents, Brokers & Service",
          "Life Insurance Policies",
          "Fine Art Holding Companies",
          "Stored Value Card Services"
        ]
      },
        {
        heading: "Retail",
        points: [
          "Garden Supply Stores",
          "Farm Equipment",
          "Fasteners, Wholesale & Retail",
          "Chain Store Supermarkets",
          "Pool Tables & Spas",
          "Apparel & Accessories",
          "Motor Vehicle Parts",
          "Jewelry, Watches, Precious Stones & Precious Metals",
          "Photographic Equipment & Supplies",
          "Auto Dealerships",
          "Consumer Electronics",
          "Industrial Equipment"
        ]
      },
      {
        heading: "Services",
        points: [
          "Auto Repair Shops",
          "Commercial Appliance Equipment & Repairs",
          "Pharmacies",
          "Healthcare",
          "Security Firms",
          "Commercial Printers",
          "Video Production",
          "Utilities & Natural Gas Resellers",
          "Retirement Communities",
          "Central Station Monitoring"
        ]
      },
      {
        heading: "Government and Charitable",
        points: [
          "Government Contractors",
          "Military Contractors",
          "Aviation Supply, Engineering & Contracting",
          "Not-for-Profit Charities"
        ]
      },
      {
        heading: "Food and Beverage",
        points: [
          "Hospitality & Restaurants",
          "Restaurant Franchisors & Franchises",
          "Foodservice Companies"
        ]
      },
      {
        heading: "Transportation, Freight & Logistics",
        points: [
          "Transportation & Trucking",
          "Commercial Moving & Logistics",
          "Less-Than-Truckload (LTL) Carriers",
          "Residential Moving & Storage",
          "Specialized Furniture Carriers",
          "Freight Delivery & Logistics"
        ]
      },
      {
        heading: "Miscellaneous",
        points: [
          "Professional Motorsports",
          "Start-up Companies",
          "Vocational Schools"
        ]
      }
]

function BulletPoints() {
  return (
    <div className='BulletPoints-container standard-padding-space'>
      <div className='container'>
        <div className='row gy-3'>
          {
            bulletData.map((ele)=>{
              return(
                <div className='col-lg-4'>
                  <div className='list-card pt-4 pb-3 px-3 h-100'>
                    <h3 className='sub-heading mb-3'>{ele.heading}</h3>
                    <ul className='ps-3' style={{color:"black"}}>
                      {
                        ele.points.map((point)=>{
                          return(
                            <li className='mb-2 body-paragraph'>{point}</li>
                          )
                        })
                      }
                    </ul>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    </div>
  )
}

export default BulletPoints